export default __webpack_public_path__ + "static/clients-financing-numbers-image-04c0ed3b50a62b49ddd095ef1ac146a5.jpg";